/* loaded by smart-asset */
export default require("./impactcity-logo-2~bpLAzftO.png")